var map = {
	"./Map": 9888,
	"./Map.jsx": 9888,
	"./admin/navButton": 4580,
	"./admin/navButton.js": 4580,
	"./admin/navButtonHeader": 9944,
	"./admin/navButtonHeader.js": 9944,
	"./admin/navLogo": 4708,
	"./admin/navLogo.js": 4708,
	"./admin/navSignOut": 1384,
	"./admin/navSignOut.js": 1384,
	"./admin/sidenav": 484,
	"./admin/sidenav.js": 484,
	"./admin/studentSelect": 2056,
	"./admin/studentSelect.js": 2056,
	"./admin/studentTable": 8240,
	"./admin/studentTable.js": 8240,
	"./admin/teacherSelect": 8696,
	"./admin/teacherSelect.js": 8696,
	"./admin/userTable": 5888,
	"./admin/userTable.js": 5888,
	"./map/constants": 2560,
	"./map/constants.js": 2560,
	"./map/features": 5964,
	"./map/features.jsx": 5964,
	"./shared/leaderboards/allTownsLeaderboard": 6560,
	"./shared/leaderboards/allTownsLeaderboard.js": 6560,
	"./shared/leaderboards/leader": 7496,
	"./shared/leaderboards/leader.js": 7496,
	"./shared/leaderboards/townLeader": 7244,
	"./shared/leaderboards/townLeader.js": 7244,
	"./shared/leaderboards/townLeaderboard": 7648,
	"./shared/leaderboards/townLeaderboard.js": 7648,
	"./shared/leaderboards/townsLeaderboard": 9216,
	"./shared/leaderboards/townsLeaderboard.js": 9216,
	"./shared/loadingSpinner": 1709,
	"./shared/loadingSpinner.js": 1709,
	"./shared/modal": 1628,
	"./shared/modal.js": 1628,
	"./shared/utils": 96,
	"./shared/utils.js": 96,
	"./students/Map": 72,
	"./students/Map.jsx": 72,
	"./students/dashboard": 316,
	"./students/dashboard.js": 316,
	"./students/leaderboards": 4396,
	"./students/leaderboards.js": 4396,
	"./students/main": 7880,
	"./students/main.js": 7880,
	"./students/market/assetModal": 7632,
	"./students/market/assetModal.js": 7632,
	"./students/market/buyCrops": 7928,
	"./students/market/buyCrops.js": 7928,
	"./students/market/buyGoods": 108,
	"./students/market/buyGoods.js": 108,
	"./students/market/buyItems": 6012,
	"./students/market/buyItems.js": 6012,
	"./students/market/buyLiveStock": 5076,
	"./students/market/buyLiveStock.js": 5076,
	"./students/market/cropRow": 6076,
	"./students/market/cropRow.js": 6076,
	"./students/market/goodsRow": 1904,
	"./students/market/goodsRow.js": 1904,
	"./students/market/liveStockRow": 6270,
	"./students/market/liveStockRow.js": 6270,
	"./students/market/market": 1828,
	"./students/market/market.js": 1828,
	"./students/market/marketButton": 6040,
	"./students/market/marketButton.js": 6040,
	"./students/market/marketCropsItem": 5924,
	"./students/market/marketCropsItem.js": 5924,
	"./students/market/marketGoodsItem": 1196,
	"./students/market/marketGoodsItem.js": 1196,
	"./students/market/marketLiveStockItem": 5416,
	"./students/market/marketLiveStockItem.js": 5416,
	"./students/market/priceChart": 6011,
	"./students/market/priceChart.js": 6011,
	"./students/property/items/crops": 9368,
	"./students/property/items/crops.js": 9368,
	"./students/property/items/goods": 8828,
	"./students/property/items/goods.js": 8828,
	"./students/property/items/livestock": 7820,
	"./students/property/items/livestock.js": 7820,
	"./students/property/items/sellAssetItem": 6544,
	"./students/property/items/sellAssetItem.js": 6544,
	"./students/property/items/sellCrops": 324,
	"./students/property/items/sellCrops.js": 324,
	"./students/property/items/sellGoods": 112,
	"./students/property/items/sellGoods.js": 112,
	"./students/property/items/sellLivestock": 8368,
	"./students/property/items/sellLivestock.js": 8368,
	"./students/property/land/StorageInfo": 3147,
	"./students/property/land/StorageInfo.js": 3147,
	"./students/property/land/buyLand": 2592,
	"./students/property/land/buyLand.js": 2592,
	"./students/property/land/buyLandItem": 9632,
	"./students/property/land/buyLandItem.js": 9632,
	"./students/property/land/land": 9360,
	"./students/property/land/land.js": 9360,
	"./students/property/land/landItem": 9028,
	"./students/property/land/landItem.js": 9028,
	"./students/property/land/manageLand": 6004,
	"./students/property/land/manageLand.js": 6004,
	"./students/property/land/sellLand": 2840,
	"./students/property/land/sellLand.js": 2840,
	"./students/property/land/sellLandItem": 5960,
	"./students/property/land/sellLandItem.js": 5960,
	"./students/property/propertyDetails": 3133,
	"./students/property/propertyDetails.js": 3133,
	"./students/property/propertyLegend": 1416,
	"./students/property/propertyLegend.js": 1416,
	"./students/property/propertySidebar": 5504,
	"./students/property/propertySidebar.js": 5504,
	"./students/property/studentHeader": 9636,
	"./students/property/studentHeader.js": 9636,
	"./students/shared/notifications": 7984,
	"./students/shared/notifications.js": 7984,
	"./students/shared/townContext": 6600,
	"./students/shared/townContext.js": 6600,
	"./students/townPage": 868,
	"./students/townPage.js": 868,
	"./students/transactions": 9996,
	"./students/transactions.js": 9996,
	"./teachers/Map": 9784,
	"./teachers/Map.jsx": 9784,
	"./teachers/leaderboards": 5596,
	"./teachers/leaderboards.js": 5596,
	"./teachers/main": 752,
	"./teachers/main.js": 752,
	"./teachers/propertyModal": 3216,
	"./teachers/propertyModal.js": 3216,
	"./teachers/shared/townContext": 6836,
	"./teachers/shared/townContext.js": 6836,
	"./teachers/townPage": 4180,
	"./teachers/townPage.js": 4180,
	"./utils": 9640,
	"./utils.js": 9640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8164;